import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import CustomExpandIcon from '../CustomExpandIcon';
import { giftQuestion } from '../../../util/Constants';
import useClasses from '../../../hooks/legacy/useClasses';
import styles from './GiftAccordian.style';

function GiftAccordian() {
  const classes = useClasses(styles);

  // Function to parse text and convert email addresses to mailto links
  const renderAnswerWithEmailLinks = (text) => {
    const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/g;
    const parts = text.split(emailRegex);

    return parts.map((part) => {
      if (emailRegex.test(part)) {
        return (
          <a
            key={part}
            href={`mailto:${part}`}
            data-test-id={`mailto-${part}`}
            style={{ color: 'inherit', textDecoration: 'underline' }}
          >
            {part}
          </a>
        );
      }
      return part;
    });
  };

  return giftQuestion.map((giftIndevidualQuestions) => (
    <Accordion
      key={giftIndevidualQuestions.question}
      sx={{
        boxShadow: 'none',
        p: 2,
        borderBottom: '1px solid #e0e0e0',
        '&:before': {
          display: 'none',
        },
        '&.Mui-expanded': {
          margin: 0,
        },
        '&:last-child': {
          borderBottom: 'none',
        },
      }}
    >
      <AccordionSummary
        expandIcon={<CustomExpandIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        sx={{
          '&.Mui-expanded': {
            minHeight: 48,
          },
          '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: '12px 0',
          },
        }}
      >
        <Typography className={classes.questionHeading}>
          {giftIndevidualQuestions.question}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0 }}>
        <Typography className={classes.answerHeading}>
          {renderAnswerWithEmailLinks(giftIndevidualQuestions.answer)}
        </Typography>
      </AccordionDetails>
    </Accordion>
  ));
}

export default GiftAccordian;
